import Vue from 'vue'
import axios from "axios"
import apiUrl from './apiUrl.js'
import Qs from 'qs'

const serviceWeb = axios.create({
  baseURL: apiUrl.baseUrl,
  ContentType: 'application/json'
})

const serviceApp = axios.create({
  baseURL: apiUrl.baseAppPath,
  ContentType: 'application/json'
})





function handleResponse(res) {
  if (res.status == 200) {
    return Promise.resolve(res.data)
  } else {
    // 在Ie9中，没有Http状态码返回
    if (res.data) {
      return Promise.resolve(res.data)
    } else {
      console.log('error');
      return Promise.resolve(res)
    }
  }
}
function get(url, query) {
  const data = Qs.stringify(query);
  // return serviceWeb.get(url, data).then(handleResponse)
  return getMock(url, query)
}

function getMock(url, query) {
  const data = Qs.stringify(query);
  return axios.get(url, data).then(handleResponse)
}

function getInAppPath(url, query) {
  const data = Qs.stringify(query);
  // return serviceApp.get(url, data).then(handleResponse)
  return getMock(url, query)
}

function post(url, query) {
  const data = Qs.stringify(query);
  return serviceWeb.post(url, data).then(handleResponse)
}

export default {
  get,
  post,
  getInAppPath,
  getMock
}



// WEBPACK FOOTER //
// ./src/api/http.js